import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const saveDepartment = async (department, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
        try {
            let Payload = {
                departmentID: department?.departmentID || 0,
                department: department?.department,
                isActive: department?.isActive !== undefined ? department.isActive : true,
            };

            const response = await fetch(`${dev_baseUrl}/Employee/saveDepartment`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(Payload),
            });

            const data = await response.json();
            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else {
                return data;
            }
        } catch (error) {
            console.error("Network error:", error);
            return {
                isError: true,
                message: "An error occurred. Please try again later.",
                error: error,
            };
        }
    } else {
        console.warn("Access token is not available.");
        return { form: "Access token is missing." };
    }
};

export const getDepartments = async (navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
        try {
            const response = await fetch(`${dev_baseUrl}/Employee/getDepartments`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else {
                return data;
            }
        } catch (error) {
            console.error("Network error:", error);
            return {
                isError: true,
                message: "An error occurred while fetching departments.",
                error: error,
            };
        }
    } else {
        console.warn("Access token is not available.");
        return { form: "Access token is missing." };
    }
};

export const deleteDepartment = async (departmentID, navigate) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        departmentID: departmentID 
      }).toString();

      const response = await fetch(`${dev_baseUrl}/Employee/deleteDepartment?${queryParams}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if(response.ok && !data.isError ){
        return data.result; 
      } 
      else {
        console.error('Server error:', data);
        return {
          isError: true,
          message: data.message || "Department failed to delete.",
        };
      }
    } catch (error) {
      console.error('Network error:', error);
      return {
        isError: true,
        message: "An error occurred while deleting department.",
        error: error,
      };
    }
  } else {
    console.warn('Access token is not available.');
    return { 
      isError: true,
      form: 'Access token is missing.' 
    };
  }
};